import { render, staticRenderFns } from "./kvSwiper.vue?vue&type=template&id=e9436b16&scoped=true&"
import script from "./kvSwiper.vue?vue&type=script&lang=js&"
export * from "./kvSwiper.vue?vue&type=script&lang=js&"
import style0 from "./kvSwiper.vue?vue&type=style&index=0&lang=css&"
import style1 from "./kvSwiper.vue?vue&type=style&index=1&id=e9436b16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9436b16",
  null
  
)

component.options.__file = "kvSwiper.vue"
export default component.exports